import PropTypes from 'prop-types'
import { useState, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { buscarDetalle } from '../../servicios/publicacionesService'
import styles from '../Publicaciones.module.css'
import DetalleCabecera from './DetalleCabecera'

const Detalle = () => {
  const [publicacion, setPublicacion] = useState({})
  const { idPublicacion } = useParams()

  const obtenerPublicacion = async () => {
    const { data } = await buscarDetalle(idPublicacion)
    setPublicacion(data)
  }

  useEffect(() => {
    obtenerPublicacion()
  }, [idPublicacion])

  return (
    <fieldset className={`fieldset ${styles.fieldset}`}>
      <div className={styles.headerPublicaciones}>
        <legend>Administrar Publicaciones</legend>
      </div>
      <DetalleCabecera
        publicacion={publicacion}
        setPublicacion={setPublicacion}
        idPublicacion={idPublicacion}
      />
    </fieldset>
  )
}

Detalle.propTypes = {
  entidad: PropTypes.shape({
    idPublicacion: PropTypes.number.isRequired
  }).isRequired,
  actualizarPantallaDetalle: PropTypes.func.isRequired,
  onActualizarPantalla: PropTypes.func.isRequired,
  idPublicacion: PropTypes.number.isRequired
}

export default Detalle
